<template>
  <div class="quickhelp-wrapper" @mouseenter="handleTabMouseOver" @mouseleave="handleTabMouseLeave">

    <div class="quickhelp-article-container has-border" ref="articleContainer">
        <div class="close-article-container" @click="closeArticleContainer">EXIT QUICK HELP</div>
        <div class="error" v-if="APIerror">Quick Help Not Available. Please Try Again Later.</div>
        <div v-show="showArticleDetails && !APIerror">
            <a href="#" @click="handleHideArticleDetails"> &lt; Back To Article List</a>
            <div class="article-body" v-html="currentArticleBody" ref="articleBody"></div>
        </div>
        <div class="article-list" v-show="!showArticleDetails && !APIerror">
            <h3>Important Articles</h3>
            <ul>
                <li v-for="(article, idx) in resultsSpecific" :key="idx"><a href="#" @click="handleShowArticleDetails(idx, resultsSpecific)">{{ article.title }}</a></li>
            </ul>
            <h3>Other Articles</h3>
            <ul>
                <li v-for="(article, idx) in resultsGeneral" :key="idx"><a href="#" @click="handleShowArticleDetails(idx, resultsGeneral)">{{ article.title }}</a></li>
            </ul>
        </div>
        <div class="search-for-more" v-show="!showArticleDetails && !APIerror">Can't Find What You Need? <a href="https://support.jasperpim.com/hc/en-us" target="_blank">Search Our Online Knowledge Base.</a></div>
        <div class="vue-details-loader alt" v-if="isLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
    </div>

    <div class="quickhelp-tab has-border" @click="openArticleContainer" ref="tab">
        Quick Help
    </div>

  </div>
</template>

<script>

import axios from 'axios';
import {gsap, Elastic, Power3} from "gsap";

export default {
    name: 'quick-help',
    props: {
        searchTerm:String,
        specificArticleIds: Array
    },
    data() {
        return {
            isLoading: false,
            APIerror: false,
            contentVisible: false,
            callAPI: true,
            count: 0,
            page: 0,
            pageCount: 0,
            perPage: 0,
            resultsGeneral: [],
            resultsSpecific: [],
            showArticleDetails: false,
            articleContainerHeight: 0,
            articleContainerWidth: 0,
            currentArticleBody: ""
        }
    },
    mounted() {
        //bounce in animation but delay by 2.5 seconds delay to catch users eye.
        this.handleIntroduceTab();

        //set size and position of the content container
        this.articleContainerWidth = Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        )
        this.articleContainerWidth = this.articleContainerWidth - 300;

        this.articleContainerHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.documentElement.clientHeight
        )

        this.articleContainerHeight = this.articleContainerHeight - 200;
        gsap.set(this.$refs.articleContainer, {width:this.articleContainerWidth, height:this.articleContainerHeight, top: (-1 * this.articleContainerHeight)});
        gsap.set(this.$refs.articleBody, {height:this.articleContainerHeight - 105});

    },
    methods: {
        handleTabMouseOver() {
            if (this.contentVisible === false) {
                gsap.killTweensOf(this.$refs.tab);
                gsap.to(this.$refs.tab, 1, {top: "28px", opacity: "1", ease: Elastic.easeOut.config(1, 0.3)});
            }
        },
        handleTabMouseLeave() {
            if (this.contentVisible === false) {
                gsap.killTweensOf(this.$refs.tab);
                gsap.to(this.$refs.tab, 0.5, {top: "20px", opacity: "0.6", ease: Elastic.easeOut.config(1, 0.3)});
            }
        },
        handleHideTab() {
            gsap.to(this.$refs.tab, 0.2, {top: "0px", ease: Power3.easeOut});
        },
        handleIntroduceTab() {
            window.setTimeout(this.handleTabMouseOver, 2500)
            window.setTimeout(this.handleTabMouseLeave, 4000)
        },
        handleHideArticleContainer() {
            gsap.to(this.$refs.articleContainer, 0.5, {top: (-1 * this.articleContainerHeight), ease: Power3.easeOut});
        },
        handleShowArticleContainer() {
            gsap.to(this.$refs.articleContainer, 0.5, {top: "24px", ease: Power3.easeOut});
        },
        handleHideArticleDetails() {
            this.showArticleDetails = false;
        },
        handleShowArticleDetails(id, targetArray) {
            this.currentArticleBody = targetArray[id].body;
            this.showArticleDetails = true;
        },
        closeArticleContainer() {
            gsap.killTweensOf(this.$refs.articleContainer);
            gsap.killTweensOf(this.$refs.tab);
            this.handleHideArticleContainer();
            this.contentVisible = false;
            this.APIerror = false;
            this.handleTabMouseLeave();
        },
        openArticleContainer() {
            gsap.killTweensOf(this.$refs.articleContainer);
            gsap.killTweensOf(this.$refs.tab);
            this.handleHideTab();
            this.contentVisible = true;
            this.handleShowArticleContainer();

            if (this.callAPI) {
                this.isLoading = true;
                axios.get('https://jasperstudioshelp.zendesk.com/api/v2/help_center/articles/search.json?query='+this.searchTerm)
                .then((response) => {
                    this.count = response.data.count;
                    this.page = response.data.page;
                    this.pageCount = response.data.page_count;
                    this.perPage = response.data.per_page;
                    this.callAPI = false;

                    this.resultsGeneral = response.data.results.filter((el) => {
                        if (this.specificArticleIds.includes(el.id)) {
                            this.resultsSpecific.push(el);
                            return false;
                        }
                        return true;
                    })
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.APIerror = true;
                    this.isLoading = false;
                });
            }
        }
    }
}
</script>

<style lang="scss">

    .has-border {
        background-color: white;
        border-width: 0 1px 1px 1px;
        border-style: solid;
        border-radius: 0  0 10px 10px;
        border-color: #E1E1E1;
    }
    .quickhelp-wrapper {
        position: absolute;
        top: -25px;
        left: 45px;
    }

    .quickhelp-tab {
        position: absolute;
        top: 0px;
        left: 0px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding-bottom: 5px;
        width: 100px;
        height: 50px;
        cursor: pointer;
        color: #576670;
    }

    .quickhelp-article-container {
        position: absolute;
        top: 0px;
        left: 0px;
        padding: 27px 10px 10px 10px;

    }

    .close-article-container {
        cursor: pointer;
        text-align: center;
        padding: 10px;
        color: #25628F;
    }

    .article-body {
        overflow: auto;
        width: 100%;
        margin-top: 10px;

        img {
            max-width: 100%;
        }
    }

    .search-for-more {
        text-align: center;
    }

    .error {
        text-align: center;
        font-size: 16px;
        color: red;
    }

</style>